import { NgModule } from '@angular/core';
import { AppModule } from './app.module';
import { AppComponent } from './app.component';
import { COOKIE_STORAGE_ADAPTER, JsCookieAdapter } from '@app/core/cookies';
import { LOCALIZATION_STRATEGY, CookieLocalizationService } from '@app/core/i18n';
import { AnalyticsModule } from '@app/analytics/analytics.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SentryModule, ModuleOptions } from '@pascaliske/ngx-sentry';
import { environment } from '@env/environment';

@NgModule({
  imports: [
    AppModule,
    BrowserAnimationsModule,
    AnalyticsModule,
    SentryModule.forRoot(environment.sentry as ModuleOptions)
  ],
  providers: [
    {
      provide: LOCALIZATION_STRATEGY,
      useClass: CookieLocalizationService
    },
    {
      provide: COOKIE_STORAGE_ADAPTER,
      useClass: JsCookieAdapter
    },
    {
      provide: 'HOST',
      useFactory: () => window.location.host
    },
    {
      provide: 'PROTOCOL',
      useFactory: () => window.location.protocol.replace(/:$/, '')
    },
    {
      provide: 'COOKIES',
      useValue: null
    },
    {
      provide: 'SERVER_TIMEZONE',
      useValue: null
    },
    // Only usefull for development purpose
    {
      provide: 'LOCALE_TRANSLATION',
      useValue: '{"HEADER.BANNER.BASELINE":{"message":"Pre-loved fashion sold by your community"}}'
    }
  ],
  bootstrap: [AppComponent]
})
export class AppBrowserModule {}
